var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"splash"},[_c('lottie',{staticClass:"splash-screen",attrs:{"options":_vm.splashDefault}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }